import { Link } from "react-router";
import { useSettings } from "../../hooks/usePosts";

interface TopbarProps {
  date: string;
  onDateChange: (date: string) => void;
}

export function Topbar({ date, onDateChange }: TopbarProps) {
  const { data: settings } = useSettings();
  const availableServices = settings?.services.filter((s) => s.available).length ?? 0;
  const totalServices = settings?.services.length ?? 0;
  const servicesHealthy = availableServices === totalServices;

  return (
    <header className="flex items-center justify-between border-b border-black/5 bg-brand-beige px-8 py-4">
      <div className="flex items-center gap-4">
        <label className="flex items-center gap-2 text-xs tracking-wider uppercase text-brand-text-dark/70">
          Datum
          <input
            type="date"
            value={date}
            onChange={(e) => onDateChange(e.target.value)}
            className="rounded-md border border-black/10 bg-white px-3 py-1.5 text-sm text-brand-text-dark focus:border-brand-blue focus:outline-none"
          />
        </label>
        {settings ? (
          <Link
            to="/settings"
            className="flex items-center gap-1.5 text-xs text-brand-text-dark/60 hover:text-brand-text-dark"
            title="Service-Status"
          >
            <span
              className={`h-2 w-2 rounded-full ${
                servicesHealthy ? "bg-emerald-500" : "bg-amber-500"
              }`}
            />
            {availableServices}/{totalServices} services
          </Link>
        ) : null}
      </div>
      {/* The sidebar already has a Generate link at the top of the nav, so
          the top-right CTA is redundant. Left this bar for the date picker
          + service health summary only. */}
    </header>
  );
}
